export const MODAL_DELETE = {
  HEAD: {
    TH: 'ยืนยันการลบ',
    EN: 'Delete'
  },
  DESCRIPTION: {
    TH: (name) => { return `คุณกำลังจะลบ ${name} ออกจากรายการ` },
    EN: (name) => { return `This will delete your ${name} from list.` }
  },
  SURE: {
    TH: 'คุณแน่ใช่หรอไม่?',
    EN: 'Are you sure?'
  },
  PLACEHOLDER: {
    TH: 'กรุณาใส่เหตุผลในการลบ... (ไม่จำเป็นต้องใส่)',
    EN: 'Tell us why you\'re delete... (Optional)'
  },
  KEEP: {
    TH: 'ยกเลิก',
    EN: 'Keep'
  },
  DELETE: {
    TH: 'ลบ',
    EN: 'Delete'
  },
  REPEAT_BOOKING_HEADER: {
    TH: 'ลบการประชุมที่เกิดซ้ำ',
    EN: 'Delete recurring schedule',
  },
}

export const MODAL_REASON = {
  HEAD: {
    TH: 'ยืนยัน',
    EN: 'Confirm'
  },
  DESCRIPTION: {
    TH: (name) => { return `คุณกำลังจะปิดการใช้งานของ ${name}` },
    EN: (name) => { return `This will close of ${name}` }
  },
  SURE: {
    TH: 'คุณแน่ใช่หรอไม่?',
    EN: 'Are you sure?'
  },
  PLACEHOLDER: {
    TH: 'กรุณาใส่เหตุผลในการปิดการใช้งาน...',
    EN: 'Tell us why you\'re close...'
  },
  KEEP: {
    TH: 'ยกเลิก',
    EN: 'Cancel'
  },
  DELETE: {
    TH: 'ยืนยัน',
    EN: 'Confirm'
  }
}

export const MODAL_STATUS = {
  COMPLELTE: {
    TH: 'เรียบร้อย',
    EN: ' Complete'
  },
  ERROR: {
    TH: 'เกิดข้อผิดพลาด',
    EN: 'ERROR'
  },
  WARNING: {
    TH: 'คำเตือน',
    EN: 'Warning'
  },
  SUCCESS: {
    TH: 'สำเร็จ!',
    EN: 'Success!'
  },
  BACK: {
    TH: 'กลับ',
    EN: 'Back'
  },
  BACK_TO_LOGIN: {
    TH: 'กลับไปหน้าล็อกอิน',
    EN: 'Back to login'
  },
  REFRESH: {
    TH: 'โหลดใหม่',
    EN: 'Refresh'
  },
  OK: {
    TH: 'ตกลง',
    EN: 'Ok'
  },
  TEXT_ERROR_1: {
    TH: 'ระบบกำลังมีปัญหา',
    EN: 'System has a problem.'
  }
}

export const MODAL_RESETPASSWORD = {
  TITLE: {
    TH: 'ลืมรหัสผ่าน?',
    EN: 'Forgot Password?'
  },
  SUBTITLE: {
    TH: 'ใส่อืเมลของท่าน',
    EN: 'Enter your email to reset your password.'
  },
  SENT_EMAIL: {
    TH: 'ลิ้งสำหรับรีเซ็ทรหัสผ่านได้ถูกส่งเข้าอีเมลของท่าน',
    EN: 'Password Reset Email Sent!'
  },
  DONE: {
    TH: 'เสร็จสิ้น',
    EN: 'Done'
  },
  SEND: {
    TH: 'ส่ง',
    EN: 'Send'
  },
  CHECK_INBOX: {
    TH: 'ตรวจสอบอีเมลของท่าน',
    EN: 'Please check your inbox to continue.'
  },
  EMAIL: {
    TH: 'อีเมล',
    EN: 'Email'
  },
  EMAIL_SEND: {
    TH: 'อีเมลได้ส่งเข้าอีเมลของเท่าน',
    EN: 'An email has been sent your rescue email,'
  },
  EMAIL_WRONG_FORMAT: {
    TH: 'อีเมลไม่ถูกต้อง',
    EN: 'Incorrect email format.'
  },
  ENTER_VALID_EMAIL: {
    TH: 'กรุณาส่งอีกเมลอีกครั้ง',
    EN: 'Please enter a valid email address'
  }
}

export const MODAL_CONFIRM = {
  HEAD: {
    TH: 'ยืนยัน',
    EN: 'Confirm'
  },
  SURE: {
    TH: 'คุณแน่ใจใช่หรือไม่?',
    EN: 'Are you sure?'
  },
  KEEP: {
    TH: 'ยกเลิก',
    EN: 'Cancel'
  },
  OK: {
    TH: 'ตกลง',
    EN: 'Ok'
  },
  CLOSE: {
    TH: 'ปิด',
    EN: 'Close'
  }
}

export const MODAL_ORDER = {
  BACK: {
    TH: 'กลับ',
    EN: 'Back',
  },
  PRINT: {
    TH: 'ปริ๊นท์',
    EN: 'Print',
  },
}

export const CRASH_MEETING_MODAL = {
  HEADER: {
    TH: 'มีบางวันไม่สามารถจองได้',
    EN: 'Some Dates Unavailable',
  },
  DESCRIPTION: {
    TH: 'มีบางวันที่เลือกไว้ไม่สามารถทำการจองได้ คุณต้องการที่จะจองวันอื่น ๆ ที่เหลืออยู่หรือไม่?',
    EN: `One or more of the dates you've selected are unavailable. Do you still want to book the remaining available dates?`,
  },
  CHANGE_DATE_BUTTON: {
    TH: 'เลือกวันใหม่',
    EN: 'Change Dates',
  },
  CONFIRM_BUTTON: {
    TH: 'ยืนยันการจอง',
    EN: 'Confirm Anyway',
  },
}

export const EDIT_RECURRING_SCHEDULE_MODAL = {
  HEADER: {
    TH: 'แก้ไขการประชุมที่เกิดซ้ำ',
    EN: 'Edit recurring schedule',
  },
  DESCRIPTION: {
    TH: 'คุณต้องการที่จะบันทึกการแก้ไข "การประชุมนี้และการประชุมที่ตามมาทั้งหมด" ใช่หรือไม่',
    EN: 'Are you sure you want to save changes on “This and follow schedules”?',
  },
  SAVE_BUTTON: {
    TH: 'บันทึก',
    EN: 'Save',
  },
}

export const EDIT_SCHEDULE_MODAL = {
  HEADER: {
    TH: 'แก้ไขการประชุม',
    EN: 'Edit schedule',
  },
  DESCRIPTION: {
    TH: 'คุณต้องการที่จะบันทึกการแก้ไขใช่หรือไม่',
    EN: 'Are you sure you want to save changes ?',
  },
  SAVE_BUTTON: {
    TH: 'บันทึก',
    EN: 'Save',
  },
}

export const MODAL_CONTROL_ROOM = {
  DONE: {
    TH: 'เสร็จสิ้น',
    EN: 'DONE'
  },
  MANUALLY: {
    TH: 'คู่มือการใช้งาน',
    EN: 'Manual'
  }
}

export const REPEAT_OPTION_STATUS = {
  THIS_SCHEDULE: 'this-schedule',
  THIS_AND_FOLLOW_SCHEDULE: 'this-and-follow-schedules',
}

export const REPEAT_OPTIONS = [
  {
    key: REPEAT_OPTION_STATUS.THIS_SCHEDULE,
    TH: 'การประชุมนี้',
    EN: 'This schedule',
  },
  {
    key: REPEAT_OPTION_STATUS.THIS_AND_FOLLOW_SCHEDULE,
    TH: 'การประชุมนี้และการประชุมที่ตามมาทั้งหมด',
    EN: 'This and follow schedules',
  },
]

export const BOOKING_DETAIL_VIEW = {
  BOOKING_VIEW: 'BOOKING_VIEW',
  MORE_VIEW: 'MORE_VIEW',
  YEAR_VIEW: 'YEAR_VIEW',
}

export const MEETING_CANNOT_BE_EDITED = {
  HEADER: {
    TH: 'การประชุมนี้ไม่สามารถแก้ไขได้',
    EN: 'Meeting cannot be edited',
  },
  DESCRIPTION: {
    GOOGLE: {
      TH: 'ขออภัยในความไม่สะดวก\nกรุณาแก้ไขข้อมูลใน Google Calendar',
      EN: 'We apologize for the inconvenience. Please return to Google Calendar to make any necessary changes.',
    },
    MICROSOFT: {
      TH: 'ขออภัยในความไม่สะดวก\nกรุณาแก้ไขข้อมูลใน Microsoft Calendar',
      EN: 'We apologize for the inconvenience. Please return to Microsoft Calendar to make any necessary changes.',
    }
   },
}
